module.exports = __webpack_public_path__ + "img/1.eb84df04.png";